export enum OutputEvent {
  addToCart = 'addToCart',
  addToMyList = 'addToMyList',
  shareBySns = 'shareBySns',
  shareByLine = 'shareByLine',
  showMyList = 'showMyList',
  showPages = 'showPages',
  showChatbot = 'showChatbot',
}

export const EventType = {
  ROTATE_AUTO: 'ROTATE_AUTO',
  ROTATE_END: 'ROTATE_END',
  ZOOM_IN: 'ZOOM_IN',
  ZOOM_OUT: 'ZOOM_OUT',
  ZOOM_RESET: 'ZOOM_RESET',
  TOGGLE_OPEN_GLASS: 'TOGGLE_OPEN_GLASS',
  ADD_TO_MY_LIST: 'ADD_TO_MY_LIST',
  RESET_DEFAULT: 'RESET_DEFAULT',
  SHARE_BY_SNS: 'SHARE_BY_SNS',
  SHOW_PAGES: 'SHOW_PAGES',
  SHOW_CHATBOT: 'SHOW_CHATBOT',
  SHOW_MY_LIST: 'SHOW_MY_LIST',
  SCREEN_SHOT: 'SCREEN_SHOT',
  SHARE_WITH_LINE: 'SHARE_WITH_LINE',
  SHARE_QUESTIONNAIRE: 'SHARE_QUESTIONNAIRE',
  SWITCH_CAMERA: 'SWITCH_CAMERA',

  MODEL_SELECTED: 'MODEL_SELECTED',
  FRAME_SELECTED: 'FRAME_SELECTED',
  TEMPLE_SELECTED: 'TEMPLE_SELECTED',
  LENS_SELECTED: 'LENS_SELECTED',
  LEN_OPTIONS_SELECTED: 'LEN_OPTIONS_SELECTED',
  LOGO_SELECTED: 'LOGO_SELECTED',
  BRIDGE_SELECTED: 'BRIDGE_SELECTED',
}
